/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { isSameArrayOfObjs } from '../../common/helpers';
import { useFormDocs } from '../../hooks';
import useServerLang from '../../hooks/useServerLang';
import Auth from '../auth';
import Content from './Content';

const Layout = ({
  user,
  lang,
  languages,
  setLanguages,
  formdocs,
  setFormdocs,
}: any) => {
  const { ar, en, updatedAt } = useServerLang();
  const { formdocs: formdocsdata } = useFormDocs();
  useEffect(() => {
    if (
      ar &&
      en &&
      lang &&
      (!languages?.updatedAt || languages?.updatedAt !== updatedAt)
    ) {
      setLanguages({ ar, en, updatedAt });
      window.location.reload();
    }
  }, [lang, ar, en, updatedAt]);
  useEffect(() => {
    if (
      formdocsdata &&
      formdocsdata?.length > 0 &&
      !isSameArrayOfObjs(formdocsdata, formdocs)
    ) {
      setFormdocs(formdocsdata);
      window.location.reload();
    }
  }, [formdocsdata]);
  return (
    <BrowserRouter>
      {!user && <Auth></Auth>}
      {user && <Content formdocs={formdocs}></Content>}
    </BrowserRouter>
  );
};
export default Layout;
